export const CAROUSEL_IMAGE_HEIGHT = 636
export const CAROUSEL_IMAGE_LOADING_HEIGHT = 556
export const LEFT_PANEL_MAX_WIDTH = 840
export const RIGHT_PANEL_MIN_WIDTH = 320
export const THUMBNAIL_IMAGE_HEIGHT = 130
export const MIN_THUMBNAIL_IMAGE_COUNT = 8

export const CAROUSEL_LOADING = 100
